import * as React from 'react';
import { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea, Button, Dialog, DialogContent, DialogTitle, DialogActions, Icon} from '@mui/material';


interface CustomCardProps {
  title: string;
  content: string;
  icon: string;  
  onReadMore: () => void;
}

const CustomCard: React.FC<CustomCardProps> = ({ title, content,icon,onReadMore }) => {
  return (
    <Card sx={{ maxWidth: 345, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginBottom: 2, alignItems:"center" ,backgroundColor:"transparent",boxShadow:"0px 0px 0px 0px"}} className='' >
      <CardActionArea>
        <CardContent style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
          
          <img src={icon} alt={`${title} icon`} width={"72px"} height={"72px"} style={{boxShadow:"14px 6px 10px 0px",borderRadius:"50px",padding:"10px",marginBottom:"10px",backgroundColor:"#f6a035",opacity:"0.9"}} className='component'/>
        
          <Typography className='text-customPurpleDark component' gutterBottom variant="h5" component="div" style={{color:"rgb(29,35,42)"}} >
           
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" style={{ maxHeight: '80px', overflow: 'hidden', textOverflow: 'ellipsis', color:"black", opacity:"1"}} className='component'>
          
            {content}
          </Typography>
        </CardContent>
      </CardActionArea>
      {content.length > 100 && (
        <Button size="small" color="primary" onClick={onReadMore} className='component'>
          Read More
        </Button>
      )}
    </Card>
  );
};

export default function ChooseCard() {
  const [open, setOpen] = useState(false);
  const [selectedContent, setSelectedContent] = useState<{ title: string; content: string } | null>(null);

  const handleOpen = (card: { title: string; content: string }) => {
    setSelectedContent(card);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedContent(null);
  };

  const cardsData = [
    { 
      title: "0% Plagiarism Content",
      content: "We’re aware of the consequences of the plagiarism, therefore provide you 100% plagiarism free content. We ensure that our experts scan the works through online plagiarism tools as well as Turnitin or WriteCheck",
      icon:"6516189.webp"
    },
    {
      title: "High Quality",
      content: "We ensure high-quality dissertation services by employing experienced researchers and writers who are experts in their fields. Our commitment to quality is unwavering, and we adhere to the highest standards in academic writing.",
      icon:"hq.webp"
    },
    {
      title: "Quality check",
      content: "We undertake the rigorous quality check and assurance process at every step of your dissertation thereby you are assured to get the accurate output. Our experts check every time and verify the given requirement.",
      icon:"qh.webp"
    },
    {
      title: "Reasonable Cost",
      content: "We strive hard to provide the ultimate dissertation research methodology writing services with high-class quality at a reasonable cost compare to the globally available service provider.",
      icon:"lp.webp"
    },
    {
      title: "24/7 Support",
      content: "Our customer support team is available 24/7 to assist you with any queries or concerns. We are committed to providing excellent support and ensuring your satisfaction with our services.",
      icon:"5175185.webp"
    },
    {
      title: "Timely Delivery",
      content: "We understand the importance of deadlines and guarantee timely delivery of all our projects. Our team works efficiently to ensure you receive your work on time, without compromising on quality.",
      icon:"td.webp"
    },
    {
      title: "Confidentiality",
      content: "We prioritize your privacy and ensure complete confidentiality of your personal information and research data. Your work is safe with us and will never be shared with third parties. ",
      icon:"confi.webp"
    },
    {
      title: "Custom Solutions",
      content: "We provide customized dissertation solutions tailored to your specific requirements. Our services are designed to meet the unique needs of each student, ensuring complete satisfaction.",
      icon:"3337508.webp"
    }
  ];

  return (
    <React.Fragment>
      {cardsData.map((card, index) => (
        <CustomCard key={index} title={card.title} content={card.content} icon={card.icon} onReadMore={() => handleOpen(card)} />
      ))}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{selectedContent?.title}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            {selectedContent?.content}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
  




